const singles = () => {
  const frame = document.querySelectorAll('[data-frame-height]');
  if(frame) {
    frame.forEach(element => {
      const selector = window.matchMedia("(min-width: 750px)") ? "img.small-hide" : "img.medium-hide";
      const img = element.querySelector(selector);
      const ratio = img.naturalWidth / img.naturalHeight;
      element.style.setProperty('min-height', `${element.clientWidth / ratio}px`);
    })
  }
}
window.addEventListener("load", function() {
  singles();
}) 
window.addEventListener('resize', function() {
  singles();
})